import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/reportsList/report/styles.scss';export default {
  "report": "_report_n8pse_1",
  "header": "_header_n8pse_7",
  "headerItem": "_headerItem_n8pse_13",
  "indicators": "_indicators_n8pse_33",
  "toggle": "_toggle_n8pse_37",
  "name": "_name_n8pse_45",
  "icon": "_icon_n8pse_51",
  "submissionDate": "_submissionDate_n8pse_59",
  "author": "_author_n8pse_65",
  "authorAvatar": "_authorAvatar_n8pse_73",
  "authorName": "_authorName_n8pse_81",
  "textFields": "_textFields_n8pse_87",
  "opened": "_opened_n8pse_94",
  "buttonBox": "_buttonBox_n8pse_98",
  "button": "_button_n8pse_98",
  "removeIcon": "_removeIcon_n8pse_121",
  "contextualMenu": "_contextualMenu_n8pse_125"
};